import React from 'react';

import useClassy from '@core/hooks/useClassy';

import styles from './index.module.scss';

interface TreeConnectorProps {
  /**
   * Indicates the kind of connector to draw based on the node position. Default
   * is `middle`.
   */
  kind: 'end' | 'middle';
}

/**
 * Renders a tree line graphic that connects child nodes up to its parent.
 */
export default function TreeConnector({ kind = 'middle' }: TreeConnectorProps) {
  const bem = useClassy(styles, 'TreeConnector');

  return (
    <svg className={bem()} fill="none" viewBox="0 0 15 29" xmlns="http://www.w3.org/2000/svg">
      {kind === 'end' ? (
        <path d="M0.912109 0V6C0.912109 10.1421 4.26997 13.5 8.41211 13.5H13.9121" />
      ) : (
        <>
          <path d="M0.912109 0L0.912108 27" />
          <path d="M0.912109 0V6C0.912109 10.1421 4.26997 13.5 8.41211 13.5H13.9121" />
        </>
      )}
    </svg>
  );
}
